import { Controller } from "stimulus";

// Keeps the browser URL in sync with the ticket open in the detail sidebar.
// When a ticket finishes loading in the ticket_detail frame (a row/card click),
// writes ?ticket=ID to the URL (replaceState, preserving the current filters) so
// the view is shareable and survives a reload — the server preloads the panel from
// that param. Closing the panel drops the param. This only mirrors state: it adds
// no history entries and never navigates.
export default class extends Controller {
  static values = { frame: String, param: { type: String, default: "ticket" } };

  connect() {
    this.onFrameLoad = this.syncFromFrame.bind(this);
    document.addEventListener("turbo:frame-load", this.onFrameLoad);
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.onFrameLoad);
  }

  // A ticket finished loading in the detail frame → reflect its id in the URL.
  syncFromFrame(event) {
    if (event.target.id !== this.frameValue) return;

    const ticketId = this.ticketIdFromFrame(event.target);
    if (ticketId) this.setParam(ticketId);
  }

  // Called by the panel's close button: remove the ticket param.
  clear() {
    this.setParam(null);
  }

  ticketIdFromFrame(frame) {
    const source = frame.getAttribute("src");
    if (!source) return null;

    const match = source.match(/\/tickets\/(\d+)/);
    return match ? match[1] : null;
  }

  setParam(value) {
    const url = new URL(window.location);
    if (value) {
      url.searchParams.set(this.paramValue, value);
    } else {
      url.searchParams.delete(this.paramValue);
    }
    window.history.replaceState({}, "", url);
  }
}
